document.addEventListener('DOMContentLoaded', function () {
  const viewMoreButton = document.getElementById('viewMoreButton');
  if (!viewMoreButton) return;

  viewMoreButton.addEventListener('click', function () {
    const categorySlug = viewMoreButton.getAttribute('data-category-slug');
    const subcategorySlug = viewMoreButton.getAttribute(
      'data-subcategory-slug',
    );
    const totalPages = parseInt(
      viewMoreButton.getAttribute('data-total-pages'),
      10,
    );
    let currentPage = parseInt(
      viewMoreButton.getAttribute('data-current-page'),
      10,
    );
    if (currentPage >= totalPages) {
      viewMoreButton.style.display = 'none';
      return;
    }
    let page = currentPage + 1;
    const url =
      subcategorySlug === 'None'
        ? `/faqs/${categorySlug}/q?page=${page}`
        : `/faqs/${categorySlug}/${subcategorySlug}/q?page=${page}`;

    fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const questionList = document.getElementById('question-list');
        if (data.questions.length > 0) {
          data.questions.forEach(function (item) {
            const li = document.createElement('li');
            li.className = 'item';
            const anchor = document.createElement('a');
            let href = `/faqs/${categorySlug}`;
            if (subcategorySlug !== 'None') {
              href += `/${subcategorySlug}`;
            }
            href += `/${item.question_slug}-${item.id}`;
            anchor.href = href;
            const img = document.createElement('img');
            img.src = `${window._Torus.STATIC_URL}images/webp/page-icon-black.webp`;
            img.alt = 'page-icon-black-image';
            img.classList.add('width--16', 'mr-1');

            anchor.appendChild(img);

            const questionText = document.createTextNode(item.question);
            anchor.appendChild(questionText);

            li.appendChild(anchor);

            questionList.appendChild(li);
          });
          const page_number = currentPage + 1;
          viewMoreButton.setAttribute('data-current-page', page_number);
          if (page_number >= totalPages) {
            viewMoreButton.style.display = 'none';
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching more questions:', error);
      });
  });
});

document.getElementById('scrollUpButton').addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});
